import { render, staticRenderFns } from "./NaviMainWrapper.vue?vue&type=template&id=69b79332"
import script from "./NaviMainWrapper.vue?vue&type=script&lang=ts"
export * from "./NaviMainWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports